<div id="enrollment-agreement">
  <div class="page1 border border-dark p-3">

    <div class="d-flex align-items-start mb-2">
      <img style="max-width:180px;" src="assets/images/AMDCBlackHorizontalJPG.jpg" class="me-3" />
      <div class="flex-grow-1 text-center">
        <h3 class="fw-bold mb-0">STUDENT ENROLLMENT AGREEMENT</h3>
        <p class="small fst-italic mb-0">Please Print</p>
      </div>
    </div>

    <!-- Student Information -->
    <div class="d-flex border-bottom pb-1 mb-1">
      <span class="fw-bold me-2" style="white-space:nowrap;">Student</span>
      <div class="d-flex flex-grow-1 gap-3">
        <div class="flex-grow-1">
          <small class="text-muted d-block" style="font-size:0.7rem;">First Name</small>
          <span>{{ primaryContact?.field_first_name || entityData?.['field_student']?.['title']?.split(' ')[0] || '' }}</span>
        </div>
        <div class="flex-grow-1">
          <small class="text-muted d-block" style="font-size:0.7rem;">Middle Initial</small>
          <span></span>
        </div>
        <div class="flex-grow-1">
          <small class="text-muted d-block" style="font-size:0.7rem;">Last Name</small>
          <span>{{ primaryContact?.field_last_name || entityData?.['field_student']?.['title']?.split(' ').slice(1).join(' ') || '' }}</span>
        </div>
      </div>
    </div>

    <div class="d-flex border-bottom pb-1 mb-1">
      <span class="fw-bold me-2">Address</span>
      <span>{{ primaryContact?.field_address?.address_line1 || '' }}</span>
    </div>

    <div class="d-flex gap-4 border-bottom pb-1 mb-1">
      <div>
        <span class="fw-bold me-1">City</span>
        <span>{{ primaryContact?.field_address?.locality || '' }}</span>
      </div>
      <div>
        <span class="fw-bold me-1">Province</span>
        <span>{{ primaryContact?.field_address?.administrative_area || '' }}</span>
      </div>
      <div>
        <span class="fw-bold me-1">Postal code</span>
        <span>{{ primaryContact?.field_address?.postal_code || '' }}</span>
      </div>
    </div>

    <div class="d-flex gap-4 border-bottom pb-1 mb-1">
      <div class="flex-grow-1">
        <span class="fw-bold me-1">Bus. Phone</span>
        <span></span>
      </div>
      <div class="flex-grow-1">
        <span class="fw-bold me-1">Res. Phone</span>
        <span>{{ primaryContact?.field_cell_phone || '' }}</span>
      </div>
    </div>

    <div class="d-flex border-bottom pb-1 mb-3">
      <span class="fw-bold me-2">E-mail</span>
      <span>{{ primaryContact?.field_email || '' }}</span>
    </div>

    <p class="small mb-2">The student agrees to purchase and the owner of the Arthur Murray&reg; Franchised Dance School agrees to provide the following course of dance instruction and/or services on the following terms and conditions including the terms and conditions on the reverse side of this agreement.</p>

    <p class="small mb-2">You may cancel this contract by notice in writing within 7 days after you sign it. If you do not cancel this contract within 7 days, you may not be able to cancel afterwards. You may send your notice by registered mail to:
      {{ this.studioInformationConfig?.field_studio_display_name?.[0]?.value }} at
      {{ this.studioInformationConfig?.field_studio_address?.[0]?.address_line1 }},
      {{ this.studioInformationConfig?.field_studio_address?.[0]?.locality }},
      {{ this.studioInformationConfig?.field_studio_address?.[0]?.administrative_area }}
      {{ this.studioInformationConfig?.field_studio_address?.[0]?.postal_code }}
      or you may deliver it there yourself. You must mail it or deliver it before the end of the 7 days. If you cancel the contract, any monies you paid will be returned to you.</p>

    <p class="small mb-2">All semester sessions are 45 minute duration with 40 minutes of full instruction and 5 minutes transition time inclusive.</p>

    <p class="small mb-3">WAIVER: I hereby waive all present and future claims for any loss, damage or personal injury sustained by the above mentioned student (hereinafter referred to as "the student") including, but not limited to, physical injury sustained by the student during classes, performances or competitions and I future release, remise and completely discharge the promoters, directors, principals and employees of the Arthur Murray&reg; Dance Studio or any competition attended by the Arthur Murray&reg; Dance Studio from any and all liability whatsoever for any injury or loss caused as a direct or indirect result of any act or omission by any of them.</p>

    <!-- Enrollment type -->
    <div class="d-flex align-items-center gap-3 mb-2 small">
      <span>Type of Enrollment (Check one)</span>
      <span class="d-flex align-items-center"><span class="border border-dark d-inline-block me-1" style="width:14px;height:14px;" [style.background]="enrollmentTypeState.original ? '#000' : '#fff'"></span> Original</span>
      <span class="d-flex align-items-center"><span class="border border-dark d-inline-block me-1" style="width:14px;height:14px;" [style.background]="enrollmentTypeState.extension ? '#000' : '#fff'"></span> Extension</span>
      <span class="d-flex align-items-center"><span class="border border-dark d-inline-block me-1" style="width:14px;height:14px;" [style.background]="enrollmentTypeState.renewal ? '#000' : '#fff'"></span> Renewal</span>
      <span class="d-flex align-items-center"><span class="border border-dark d-inline-block me-1" style="width:14px;height:14px;" [style.background]="enrollmentTypeState.service ? '#000' : '#fff'"></span> Service</span>
    </div>

    <p class="small fst-italic mb-2">The expiry date of this agreement is <span class="fw-bold border-bottom px-2">{{ expirationDate ? (expirationDate | date) : '____________' }}</span></p>

    <!-- Lesson table -->
    <table class="table table-bordered text-center small mb-2">
      <tr>
        <td class="fw-bold">PRIVATE LESSONS</td>
        <td class="fw-bold">CLASS LESSONS</td>
        <td class="fw-bold">DANCE PARTY LESSONS</td>
        <td class="fw-bold">TUITION</td>
        <td class="fw-bold">DISCOUNT</td>
        <td class="fw-bold">{{ taxLabel }}</td>
        <td class="fw-bold">BALANCE DUE</td>
      </tr>
      <tr>
        <td>{{ entityData?.['field_enrollment_lesson_count'] || '' }}</td>
        <td></td>
        <td></td>
        <td>${{ getOriginalPackageCost() | number:'1.2-2' }}</td>
        <td>${{ getDiscount() | number:'1.2-2' }}</td>
        <td>${{ getGstAmount() | number:'1.2-2' }}</td>
        <td>${{ calculateTotalTuition() | number:'1.2-2' }}</td>
      </tr>
    </table>

    <table class="table table-bordered small mb-3">
      <tr>
        <td class="fw-bold text-center">TYPE OF SERVICE(S)</td>
        <td class="fw-bold text-center" style="width:25%">TUITION</td>
      </tr>
      <tr>
        <td>{{ getPackageName() }}<span *ngIf="getNotes()" class="d-block fst-italic">{{ getNotes() }}</span></td>
        <td>${{ getSubtotal() | number:'1.2-2' }}</td>
      </tr>
    </table>

    <!-- Acknowledgment + balance -->
    <p class="small mb-1">The Student acknowledges a total balance of <span class="border-bottom px-3 fw-bold">${{ calculateTotalTuition() | number:'1.2-2' }}</span> for the instruction and / or service(s) described above</p>
    <p class="small mb-2">and agrees to pay <span class="border-bottom px-3 fw-bold">${{ getDownPaymentAmount() | number:'1.2-2' }}</span> today and the balance as follows:</p>

    <div *ngIf="isInstallmentAgreement && allPaymentRows.length" class="mb-3" style="max-width:420px;">
      <ng-container *ngIf="areAllPaymentAmountsSame(); else detailedPayments">
        <table class="table table-bordered text-center small mb-1">
          <tr>
            <th>Number of Payments</th>
            <th>Amount of Payments</th>
            <th>Payments Due</th>
          </tr>
          <tr>
            <td>{{ allPaymentRows.length }}</td>
            <td>${{ allPaymentRows[0].amount | number:'1.2-2' }}</td>
            <td>{{ firstPaymentDate ? (firstPaymentDate | date) : 'Not specified' }}</td>
          </tr>
        </table>
      </ng-container>
      <ng-template #detailedPayments>
        <table class="table table-bordered text-center small mb-1">
          <tr>
            <th>Payment #</th>
            <th>Amount</th>
            <th>Due Date</th>
          </tr>
          <tr *ngFor="let payment of allPaymentRows; let i = index">
            <td>{{ i + 1 }}</td>
            <td>${{ payment.amount | number:'1.2-2' }}</td>
            <td>{{ payment.date ? (payment.date | date) : '' }}</td>
          </tr>
        </table>
      </ng-template>
      <p class="small mb-0">Payments due as scheduled above, until paid in full.</p>
    </div>

    <!-- Studio box + signatures -->
    <div class="row">
      <div class="col-6">
        <div class="border border-dark p-2 text-center small mb-2">
          <p class="fw-bold mb-0">{{ this.studioInformationConfig?.field_studio_address?.[0]?.organization || this.studioInformationConfig?.field_studio_display_name?.[0]?.value || '' }}</p>
          <p class="mb-0">{{ this.studioInformationConfig?.field_studio_address?.[0]?.address_line1 }},
            {{ this.studioInformationConfig?.field_studio_address?.[0]?.locality }},
            {{ this.studioInformationConfig?.field_studio_address?.[0]?.administrative_area }}
            {{ this.studioInformationConfig?.field_studio_address?.[0]?.postal_code }}</p>
          <p class="mb-0">Phone: {{ this.studioInformationConfig?.field_studio_phone_number?.[0]?.value }}</p>
          <p class="mb-0">{{ this.studioInformationConfig?.field_studio_website?.[0]?.uri }}</p>
          <p class="mb-0" *ngIf="this.studioInformationConfig?.field_studio_vat_number?.[0]?.value">GST # {{ this.studioInformationConfig?.field_studio_vat_number?.[0]?.value }}</p>
        </div>
        <ng-container *ngIf="displaySigned">
          <p class="small mb-0">By:</p>
          <div class="border-bottom" style="height:30px;">
            <img *ngIf="displaySignatures && (_enrollmentEntityData?.['field_representative_signature']?.[0]?.['url'] || entityData?.field_representative_signature?.url)"
                 class="img-fluid" style="max-height:28px;"
                 [src]="_enrollmentEntityData?.['field_representative_signature']?.[0]?.['url'] || entityData?.field_representative_signature?.url" />
          </div>
          <small class="text-muted">Studio Representative</small>
        </ng-container>
      </div>
      <div class="col-6" *ngIf="displaySigned">
        <p class="small mb-2">Signed this <span class="fw-bold">{{ (this.entityData?.['field_sale_date']?.value || this.entityData?.['field_sale_date']) | date }}</span></p>
        <p class="small fw-bold mb-0">THE STUDENT HEREBY ACKNOWLEDGES THAT:</p>
        <p class="small mb-2">(1) (S)he has read the terms and conditions on the reverse side of this agreement; and (2) they form part of this agreement</p>
        <div class="border-bottom" style="height:30px;">
          <img *ngIf="displaySignatures && (_enrollmentEntityData?.['field_signature']?.[0]?.['url'] || entityData?.field_signature?.url)"
               class="img-fluid" style="max-height:28px;"
               [src]="_enrollmentEntityData?.['field_signature']?.[0]?.['url'] || entityData?.field_signature?.url" />
        </div>
        <small class="text-muted">Student's Signature</small>
      </div>
    </div>

  </div>

  <!-- The School's/Student's Rights and Obligations back page is generated by
       getEnrollmentAgreementBackpageContent() (enrollment-agreement-backpage.content.ts)
       and rendered/printed after this agreement, same as the other templates. -->
</div>
